import { Navigate, Route, Routes } from 'react-router';
import { AppShell } from '@/components/layout/AppShell';
import { DemoPage } from '@/features/auth/DemoPage';
import { HomeRedirect } from '@/features/auth/HomeRedirect';
import { LoginPage } from '@/features/auth/LoginPage';
import { RegisterPage } from '@/features/auth/RegisterPage';
import { CajaPage } from '@/features/caja/CajaPage';
import { CierresPage } from '@/features/caja/CierresPage';
import { AparienciaPage } from '@/features/configuracion/AparienciaPage';
import { ConfigLayout } from '@/features/configuracion/ConfigLayout';
import { DominioPage } from '@/features/configuracion/DominioPage';
import { EquipoPage } from '@/features/configuracion/EquipoPage';
import { GeneralPage } from '@/features/configuracion/GeneralPage';
import { SuscripcionPage } from '@/features/configuracion/SuscripcionPage';
import { EstadisticasPage } from '@/features/estadisticas/EstadisticasPage';
import { MasPage } from '@/features/mas/MasPage';
import { MenuPage } from '@/features/menu/MenuPage';
import { NotFoundPage } from '@/features/NotFoundPage';
import { OnboardingPage } from '@/features/onboarding/OnboardingPage';
import { PreciosPage } from '@/features/precios/PreciosPage';
import { ResumenPage } from '@/features/resumen/ResumenPage';
import { RedirectIfAuthenticated, RequireAuth } from '@/lib/auth';

/**
 * Rutas (react-router 7, modo declarativo).
 * Las páginas de la fase B ya están enrutadas: solo hay que reemplazar el contenido de su archivo.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <RedirectIfAuthenticated>
            <LoginPage />
          </RedirectIfAuthenticated>
        }
      />
      <Route
        path="/registro"
        element={
          <RedirectIfAuthenticated>
            <RegisterPage />
          </RedirectIfAuthenticated>
        }
      />
      <Route path="/demo" element={<DemoPage />} />

      <Route
        path="/"
        element={
          <RequireAuth>
            <HomeRedirect />
          </RequireAuth>
        }
      />
      <Route
        path="/onboarding"
        element={
          <RequireAuth>
            <OnboardingPage />
          </RequireAuth>
        }
      />

      <Route
        path="/l/:localId"
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="resumen" replace />} />
        <Route path="resumen" element={<ResumenPage />} />
        <Route path="caja" element={<CajaPage />} />
        <Route path="caja/cierres" element={<CierresPage />} />
        <Route path="menu" element={<MenuPage />} />
        <Route path="precios" element={<PreciosPage />} />
        <Route path="estadisticas" element={<EstadisticasPage />} />
        <Route path="mas" element={<MasPage />} />
        <Route path="configuracion" element={<ConfigLayout />}>
          <Route index element={<Navigate to="general" replace />} />
          <Route path="general" element={<GeneralPage />} />
          <Route path="apariencia" element={<AparienciaPage />} />
          <Route path="dominio" element={<DominioPage />} />
          <Route path="equipo" element={<EquipoPage />} />
          <Route path="suscripcion" element={<SuscripcionPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
